import { render, staticRenderFns } from "./vis-inner-layout.vue?vue&type=template&id=2f7bfa8d"
import script from "./vis-inner-layout.vue?vue&type=script&lang=js"
export * from "./vis-inner-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports